import { useCallback, useEffect, useState } from 'react'
import { ReasonEntry } from './storage'
import { getReasonStorage } from './provider'

export function useReasonHistory(scope: string) {
  const [entries, setEntries] = useState<ReasonEntry[]>([])

  const reload = useCallback(async () => {
    const list = await getReasonStorage().list(scope)
    setEntries(list)
  }, [scope])

  useEffect(() => {
    reload()
  }, [reload])

  const commit = useCallback(
    async (text: string) => {
      await getReasonStorage().commit(scope, text)
      await reload()
    },
    [scope, reload],
  )

  const remove = useCallback(
    async (text: string) => {
      await getReasonStorage().remove(scope, text)
      await reload()
    },
    [scope, reload],
  )

  return { entries, commit, remove, reload }
}
